import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { useHistory } from 'react-router-dom'

import ScribbleBackground from 'components/ScribbleBackground'
import UnauthenticatedLayout, { UNAUTHENTICATED_BACKGROUND_KEYS } from 'components/UnauthenticatedLayout'

import RegionNotSupported from './RegionNotSupported'
import NoInternetConnection from './NoInternetConnection'

import { FullScreenContainer, Container } from './styles'

const DEFAULT_TIMEOUT = 15000 // 15s
const MAX_TIMEOUT = 3600000 // 1hr

const NetworkError = ({ isNoInternetError, isRegionCheckSuccess, initApp }) => {
  const history = useHistory()
  const [checkTimeout, setCheckTimeout] = useState(0)

  useEffect(() => {
    const resetTimeout = () => {
      setCheckTimeout(0)
    }
    window.addEventListener('online', resetTimeout)
    return () => window.removeEventListener('online', resetTimeout)
  }, [setCheckTimeout])

  useEffect(() => {
    if (isRegionCheckSuccess) {
      console.log('[Network] Connectivity restored, navigating to Main Screen') // eslint-disable-line no-console
      // send user back to home screen
      history.replace('/')
      // eslint-disable-next-line consistent-return
      return
    }
    const timeoutId = setTimeout(
      () =>
        initApp(() => {
          const nextCheckTimeout = Math.min(Math.max(checkTimeout * 2, DEFAULT_TIMEOUT), MAX_TIMEOUT)
          console.log(`[Network] Retrying in ${nextCheckTimeout} ms`) // eslint-disable-line no-console
          setCheckTimeout(nextCheckTimeout)
        }),
      checkTimeout,
    )
    // eslint-disable-next-line consistent-return
    return () => clearTimeout(timeoutId)
  }, [history, isRegionCheckSuccess, initApp, checkTimeout, setCheckTimeout])

  return (
    <FullScreenContainer>
      <UnauthenticatedLayout backgroundKey={UNAUTHENTICATED_BACKGROUND_KEYS.peopleWithLogo}>
        <ScribbleBackground>
          <Container>{isNoInternetError ? <NoInternetConnection /> : <RegionNotSupported />}</Container>
        </ScribbleBackground>
      </UnauthenticatedLayout>
    </FullScreenContainer>
  )
}

NetworkError.propTypes = {
  isNoInternetError: PropTypes.bool.isRequired,
  isRegionCheckSuccess: PropTypes.bool.isRequired,
  initApp: PropTypes.func.isRequired,
}

export default NetworkError
